import React from 'react';
import { FlowProps } from './Flow.interface';
import { MaturityDescriptions, ServicesData } from 'app/utils';
import styles from './Flow.module.scss';
import { getBootstrapApp, getService, useAppSelector } from 'app/redux';
import { SERVICE_NAMES } from 'app/utils/consts';
import { ScrollButton } from 'app/components';

export const Flow: React.FC<FlowProps> = ({ service }) => {
  const bootstrap = useAppSelector(getBootstrapApp);
  const currentService = useAppSelector(getService);
  const services = bootstrap.services;
  if (!(service in ServicesData)) return <></>;

  const hideLetsTry =
    currentService === SERVICE_NAMES.COVERAGE_CHECK_V2 ||
    currentService === SERVICE_NAMES.IGPR_SCORE;

  return (
    <div className={styles['policy-comparison']} id="flow">
      {currentService && <ScrollButton hideLetsTry={hideLetsTry} />}
      <div className={styles.wrapper}>
        <div>
          <div className={styles.logoWrap}>
            <h3 className={styles['heading-3']}>
              {ServicesData[service].FlowHeading}
            </h3>
          </div>
          <div className={styles['flow-area']}>
            <img src={ServicesData[service].FlowImage} alt="" aria-hidden />
          </div>
        </div>

        <div className={styles.text}>
          <h4 className={styles['heading-4']}>Service Description</h4>
          <dl>
            <dt>Input</dt>
            <dd>{ServicesData[service].FlowInput}</dd>
            <dt>Task</dt>
            <dd id="tasks">{ServicesData[service].FlowTask}</dd>
            <dt>Output</dt>
            <dd>{ServicesData[service].FlowOutput}</dd>
          </dl>

          <div className={styles.maturity}>
            <span
              style={{ backgroundColor: 'var(--color-gradiant-blue-20)' }}
              className={styles.maturity}
            ></span>
            {['Medium', 'High'].includes(
              String(services[service]?.maturity)
            ) && (
              <span
                style={{ backgroundColor: 'var(--color-gradiant-blue-40)' }}
                className={styles.maturity}
              ></span>
            )}
            {['High'].includes(String(services[service]?.maturity)) && (
              <span
                style={{ backgroundColor: 'var(--color-gradiant-blue-60)' }}
                className={styles.maturity}
              ></span>
            )}
            Maturity level
          </div>
          <p>
            {MaturityDescriptions[String(services[service]?.maturity)]?.replace(
              '<service>',
              services[service].name
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
